import { ClientInquiryTemplate } from './templates/ClientInquiryTemplate';
import { EmailPayloadTemplate } from './types/EmailTemplate.type';
export class EmailService {
    constructor() {
        this.buildPayload = async (payload) => {
            const flattenPayload = this.flattenPayload(payload);
            const templateContent = await this.loadTemplate(payload.template);
            const body = this.interpolateTemplate(templateContent, flattenPayload);
            const bodySanitized = this.encodeHtmlEntities(body);
            return {
                ntfnTmpl: 'DEFAULT_NOTIF',
                recipients: [
                    {
                        recpId: payload.recipient,
                        recpCtx: 'Email_ID',
                        recpTyp: 'TO'
                    }
                ],
                ntfnSubject: payload.subject,
                ntfnTmpData: [
                    {
                        key: 'body',
                        value: bodySanitized
                    }
                ]
            };
        };
        this.send = async (params) => {
            if (!params) {
                return Promise.resolve({
                    success: false,
                    message: 'Payload is required'
                });
            }
            const location = window.location.href;
            const payload = {
                ...params,
                sender: 'no-reply@ampf.com',
                year: params.year ?? new Date().getFullYear().toString(),
                recipient: params.overrideRecipient ?? params.recipient
            };
            const body = JSON.stringify(await this.buildPayload(payload));
            const subdomain = /^(http|https):\/\/www\.ameriprise.com\//.test(location)
                ? 'secure'
                : 'secure-01.qa';
            return fetch(`https://${subdomain}.ameriprise.com/cis.svc/pb/contactAdvisor?$format=json`, {
                method: 'POST',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'OData-Version': '4.0',
                    consumer: 'id=A0163796-61J0RSA3VPQ39ANK;type=WEB'
                },
                body: body
            })
                .then(resp => {
                if (resp.status !== 201) {
                    return {
                        success: false,
                        message: `HTTP error: ${resp.status}`
                    };
                }
                return { success: true, message: 'sent' };
            })
                .catch(() => {
                return {
                    success: false,
                    message: 'An error occurred while sending the email.'
                };
            });
        };
    }
    flattenPayload(obj, parentKey = '', delimiter = '.') {
        const flattened = {};
        for (const key in obj) {
            if (Object.prototype.hasOwnProperty.call(obj, key)) {
                const newKey = parentKey ? `${parentKey}${delimiter}${key}` : key;
                const value = obj[key];
                if (typeof value === 'object' && value !== null) {
                    Object.assign(flattened, this.flattenPayload(value, newKey, delimiter));
                }
                else {
                    flattened[newKey] = String(value);
                }
            }
        }
        return flattened;
    }
    async loadTemplate(templateName) {
        if (!/^[a-zA-Z0-9-]+$/.test(templateName)) {
            throw new Error('Invalid template name. Only alphanumeric characters and dashes are allowed.');
        }
        if (templateName === EmailPayloadTemplate.CLIENT_INQUIRY) {
            return ClientInquiryTemplate;
        }
        throw new Error('Failed to load the email template.');
    }
    interpolateTemplate(templateContent, variables) {
        // remove line breaks
        const sanitizedTemplate = templateContent.replace(/(\r\n|\n|\r)/g, '');
        // perform interpolation
        return sanitizedTemplate.replace(/{{([a-zA-Z0-9.]+)}}/g, (_, key) => {
            return variables[key.trim()] || '';
        });
    }
    encodeHtmlEntities(str) {
        const htmlEntities = {
            '&': '&amp;',
            '<': '&lt;',
            '>': '&gt;',
            '"': '&quot;'
        };
        return Object.keys(htmlEntities).reduce((encodedStr, char) => {
            const entity = htmlEntities[char];
            return encodedStr.replace(new RegExp(char, 'g'), entity);
        }, str);
    }
}
